import type { AlertDto } from "@/lib/api/types";
import type { AlertStreamEntry } from "@/store/realtime";

import { alertDtoFromStreamEntry } from "./stream-to-alert";

export function mergeHistoryAndStream(history: AlertDto[], stream: AlertStreamEntry[]): AlertDto[] {
  const fromStream = stream.map(alertDtoFromStreamEntry);
  const byId = new Map<string, AlertDto>();
  for (const a of history) {
    byId.set(a.id, a);
  }
  for (const a of fromStream) {
    if (!byId.has(a.id)) {
      byId.set(a.id, a);
    }
  }
  return Array.from(byId.values()).sort(
    (a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime(),
  );
}

export function filterAlertsBySeverity(alerts: AlertDto[], severity: string | null): AlertDto[] {
  if (!severity) {
    return alerts;
  }
  const target = severity.toLowerCase();
  return alerts.filter((a) => (a.severity ?? "").toLowerCase() === target);
}

export function filterAlertsByStatus(
  alerts: AlertDto[],
  status: "active" | "resolved" | null,
): AlertDto[] {
  if (!status) {
    return alerts;
  }
  return alerts.filter((a) => (a.status ?? "active") === status);
}
